module.exports = __webpack_public_path__ + "static/media/20170624-_DSC078810.47ce8d4a.jpg";